import { render, staticRenderFns } from "./PlanModal.vue?vue&type=template&id=4930ccbf&scoped=true&"
import script from "./PlanModal.vue?vue&type=script&lang=ts&"
export * from "./PlanModal.vue?vue&type=script&lang=ts&"
import style0 from "./PlanModal.vue?vue&type=style&index=0&id=4930ccbf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4930ccbf",
  null
  
)

export default component.exports